import React from "react";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import Instructions from "../instructions/Instructions";
import AiAssessmentQuestions from "../aiAssessmentQuestions/AiAssessmentQuestions";
import AiAssessmentResult from "./AiAssessmentResult";
import AiAssessmentEvaluate from "./AiAssessmentEvaluate";
import AssessmentBlocked from "./AssessmentBlocked";
import { useCurrentApplication } from "../../../../Context/CurrentApplicationContext/CurrentApplicationContext";

const AiAssessmentContent: React.FC = () => {
  const { currentStep, aiAssessmentQuestions, isRoundFinished ,currentSession } =
    useAIAssessmentContext();

  const { jobApplication, isInitDone } = useCurrentApplication();

  const getAiAssessmentContent = (step: number) => {
    if (step === -1) {
      if (isInitDone) {
        if (jobApplication?.status === "applied") {
          return <Instructions interviewSession={currentSession}/>;
        } else {
          return <AssessmentBlocked status={jobApplication?.status ?? ""} />;
        }
      }
    } else if (step >= 0 && step < aiAssessmentQuestions.length) {
      return <AiAssessmentQuestions />;
    } else if (step >= aiAssessmentQuestions.length && isRoundFinished) {
      return <AiAssessmentResult />;
    } else if (step >= aiAssessmentQuestions.length && !isRoundFinished) {
      return <AiAssessmentEvaluate />;
    }
  };

  return (
    <div
      className="ai-assessment-content-wrapper"
      style={{ maxWidth: "1400px", margin: "0 auto" }}
    >
      {getAiAssessmentContent(currentStep)}
    </div>
  );
};

export default AiAssessmentContent;
